import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";
const baseUrl = new APISettings().getApiURL();

class WorkflowApi<Workflow> extends BaseAPI {
    public getAllWorkflows: () => Promise<Workflow> = async () => {
        return (await BaseAPI.axios.get(`${baseUrl}/workflow`)).data.output;
    }

    public getWorkflowById: (id: number) => Promise<Workflow> = async (id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/workflow/${id}`)).data.output;
    }
}

export const workflowAPI = new WorkflowApi();